import React from 'react';

import _ from '../../locale';
import { Resource } from '../../types';
import { parseApiError } from '../../utility/api-helpers';
import { ConfirmationModal } from '../index';
import locale from './locale';

type Props = {
    title: string;
    resource: Resource | null;
    isVisible: boolean;
    onSubmit: (id: number) => void;
    onClose: () => void;
    deleteResource: (id: number) => void;
};

type State = {
    errors: any;
    isSubmitting: boolean;
};

class DeleteResourceModal extends React.PureComponent<Props, State> {
    state: State = {
        errors: null,
        isSubmitting: false,
    };

    handleSubmit = (e) => {
        e.preventDefault();

        const { onSubmit, resource, deleteResource } = this.props;
        const { isSubmitting } = this.state;

        if (isSubmitting || !resource || !deleteResource) {
            return;
        }

        this.setState({ isSubmitting: true });

        deleteResource(resource.id)
            .then((res) => {
                this.handleClose();
                onSubmit(resource.id);
            })
            .catch(this.onError);
    };

    handleClose = () => {
        this.props.onClose();
        this.clear();
    };

    clear = () => this.setState({ errors: null, isSubmitting: false });

    onError = (err) => {
        this.setState({
            isSubmitting: false,
            errors: parseApiError(err),
        });
    };

    render() {
        const { isVisible, title } = this.props;
        const { isSubmitting, errors } = this.state;

        return (
            <ConfirmationModal
                title={title}
                error={errors}
                message={_(locale.deleteMessage)}
                submitLabel={_(locale.confirmLabel)}
                isVisible={isVisible}
                isSubmitting={isSubmitting}
                onSubmit={this.handleSubmit}
                onClose={this.handleClose}
            />
        );
    }
}

export default DeleteResourceModal;
